var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
import moment from "moment";
import settings from "../../../../appsettings.json";
export const getModel = () => {
    return axiosPrivate.get(`/Account/GetModel?timestamp=${new Date().getTime()}`);
};
export const getSubscriptions = (onSuccess, onError) => {
    return axiosPrivate.get(`/Account/GetSubscriptions?timestamp=${new Date().getTime()}`).then(onSuccess).catch(onError);
};
export const getSubscriptionOrders = (subscriptionLinkId, onSuccess, onError) => {
    return axiosPrivate
        .get(`/Account/GetSubscriptionOrders?subscriptionLinkId=${subscriptionLinkId}`)
        .then(onSuccess)
        .catch(onError);
};
export const pauseSubscription = (id, orderIdsToCancel, onSuccess, onError) => {
    return axiosPrivate
        .post(`/Account/PauseSubscription`, { orderId: id, OrderIdsToCancel: orderIdsToCancel })
        .then(onSuccess)
        .catch(onError);
};
export const resumeSubscription = (id, onSuccess, onError) => {
    return axiosPrivate.post(`/Account/ResumeSubscription`, { orderId: id }).then(onSuccess).catch(onError);
};
export const cancelSubscription = (id, cancelReason, orderIdsToCancel, onSuccess, onError) => {
    return axiosPrivate
        .post(`/Account/CancelSubscription`, {
        OrderId: id,
        Value: cancelReason.Value,
        Note: cancelReason.Note,
        OrderIdsToCancel: orderIdsToCancel,
    })
        .then(onSuccess)
        .catch(onError);
};
export const getOrdersByDate = (startDate, endDate, fetchAllOrders, pageIndex, pageSize, onSuccess, onError) => {
    return axiosPrivate
        .get(`/Account/GetOrders?from=${moment(startDate).format("L")}
      &to=${moment(endDate).format("L")}
      &fetchAllOrders=${fetchAllOrders}
      &pageIndex=${pageIndex}
      &pageSize=${pageSize}`)
        .then(onSuccess)
        .catch(onError);
};
export const getUpcomingOrders = (pageIndex, pageSize, onSuccess, onError) => {
    return axiosPrivate
        .get(`/Account/GetUpcomingOrders?pageIndex=${pageIndex}&pageSize=${pageSize}`)
        .then(onSuccess)
        .catch(onError);
};
export const getSkipDayData = () => {
    return axiosPrivate.get("/Account/GetSkipDays");
};
export const updateSkipDays = (date, skip) => {
    return axiosPrivate.post("/Account/UpdateSkipDays", [{ customerDate: date, skip }]);
};
export const getCustomerInfo = (onSuccess, onError) => {
    return axiosPrivate.get("/Account/CustomerInfo").then(onSuccess).catch(onError);
};
export const updateCustomer = (updatedCustomerInfo) => {
    return axiosPrivate.put("/Account/CustomerInfo", updatedCustomerInfo);
};
export const getPickupLocation = (locationSku) => {
    return axiosPrivate.get(`/Account/GetPickupLocation?locationSku=${locationSku}`);
};
export const validatePostalCode = (postalCode) => {
    return axiosPrivate.get(`/Account/ValidatePostalCode?postalCode=${postalCode}`);
};
/**
 * Used on the Account/Orders page to select or update an order's pickup or delivery address.
 * @param {*} newLocation
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const updateOrderDeliveryPickupLocation = (newLocation, onSuccess, onError) => {
    return axiosPrivate.post("/Account/OrderInfo/OrderAddressLocation", newLocation).then(onSuccess).catch(onError);
};
/**
 * Used on the Account/Orders page to charge the customer if the delivery method change results in a balance
 * @param {*} newLocation
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const updateOrderDeliveryPickupLocationWithCharge = (newLocation, onSuccess, onError) => {
    return axiosPrivate
        .post("/Account/OrderInfo/OrderAddressLocationWithCharge", newLocation)
        .then(onSuccess)
        .catch(onError);
};
/**
 * Used on the subscriptions page to select an order's pickup or delivery address.
 * @param newLocation
 * @param _balance -- Unused here; present only to match the shared function signature.
 * @param _giftCardId -- Unused here; present only to match the shared function signature.
 * @param onSuccess
 * @param onError
 * @returns
 */
export const updateSubscriptionDeliveryPickupLocation = (newLocation, _balance, // Unused here; present only to match the shared function signature.
_giftCardId, // Unused here; present only to match the shared function signature.
onSuccess, onError) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield axiosPrivate.post("/Account/OrderInfo/SubscriptionAddressLocation", newLocation);
        onSuccess(res.data); // Return res.data to match shared success function expected value.
    }
    catch (error) {
        onError(error);
    }
});
/**
 * Confirms the extra step for payment before updating the order
 * @param {*} newLocation
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const confirmThenUpdateOrderDelivery = (newLocation, onSuccess, onError) => {
    return axiosPrivate.post("/Account/OrderInfo/ConfirmThenUpdate", newLocation).then(onSuccess).catch(onError);
};
/**
 * ACCOUNT/DELIVERY ADDRESSES PAGE
 * Mapbox forward geocoding request, which is called in the getCompanyProximity request, below.
 * @param {*} address
 * @param {*} mapCountry
 * @returns
 */
export const getCompanyCoords = (address) => {
    const encodedAddress = encodeURIComponent(address);
    return axiosPrivate.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedAddress}.json?proximity=ip&access_token=${settings.MapboxApiKey}&autocomplete=true`);
};
/**
 * ACCOUNT/DELIVERY ADDRESSES PAGE
 * @param {*} addressData
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const addUpdateAccountDeliveryAddress = (addressData, onSuccess, onError) => {
    return axiosPrivate.post("/Account/AddUpdateAccountDeliveryAddress", addressData).then(onSuccess).catch(onError);
};
